import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';

import { ISearchUser } from '@account-users/user/models/ISearchUser';
import { UsersLicensPermissions } from '@account-users/account/models/LicensePermissionList';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserListComponent {
  @Input() users: ISearchUser[] = [];
  @Input() isLoadingUsers = false;
  @Input() accountUserSearch: boolean;
  @Input() selectedUsers: ISearchUser[] = [];
  @Input() selectedPermissions: UsersLicensPermissions[] = [];

  @Output() navigate: EventEmitter<ISearchUser> = new EventEmitter();
  @Output() editSelectedUsers: EventEmitter<void> = new EventEmitter();
  @Output() selectUser: EventEmitter<ISearchUser> = new EventEmitter();
  @Output() selectAllUsers: EventEmitter<ISearchUser[]> = new EventEmitter();

  onSelectAll(select: boolean) {
    const selectedUsers = select ? this.users : [];
    this.selectAllUsers.emit(selectedUsers);
  }

  toggleUserToSelected(user: ISearchUser) {
    this.selectUser.emit(user);
  }

  isUserChecked(userId, accountId) {
    return this.selectedUsers.some(
      (user) => user.userId === userId && user.accountId === accountId,
    );
  }

  goTo(user: ISearchUser) {
    this.navigate.emit(user);
  }
}
